export enum EMessageDispatchType {
  EMAIL = 'Email',
  INTERNAL_NOTIFICATION = 'InternalNotification',
  EXTERNAL_NOTIFICATION = 'ExternalNotification',
}
